
export default {
  name: 'WhyUseNurole',
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  data() {
    const activeSlideIndex = 0
    const shouldCollapseAll = true
    return {
      activeSlideIndex,
      shouldCollapseAll,
    }
  },

  computed: {
    componentHeader() {
      return 'Why boards hire using Nurole'
    },
    activeSlide() {
      return this.slice.items[this.activeSlideIndex]
    },
  },
  methods: {
    isActiveMobile(index) {
      return this.activeSlideIndex === index && !this.shouldCollapseAll
    },
    selectActiveSlide(index) {
      this.shouldCollapseAll =
        this.activeSlideIndex === index && !this.shouldCollapseAll
      this.activeSlideIndex = index
    },
    next(index) {
      const nextIndex = index === this.slice.items.length - 1 ? 0 : index + 1
      this.selectActiveSlide(nextIndex)
    },
    previous(index) {
      const previousIndex =
        index === 0 ? this.slice.items.length - 1 : index - 1
      this.selectActiveSlide(previousIndex)
    },
  },
}
